<template>
	<div
    class="app-header-profile"
    :class="{ 'router-link-active': isOpen }"
    ref="wrapRef"
  >

		<button class="name" type="button" @click="toggleMenu">
			{{ partnerName }}
		</button>

		<div v-if="isOpen" class="popup">

			<header class="partner">
				<VIcon material="domain" theme="outlined"/>
				<span>{{ partnerName }}</span>
			</header>

			<hr>

			<button class="item" type="button" @click="goToProfile">
				<VIcon material="account_circle" theme="outlined"/>
				Профиль
			</button>

			<hr>

			<AppHeaderNavDropdown
				side="left"
				ref="dropdownRef"
				class="item"
				material="fork_right"
        :auto-open-search-picker="false"
				:items="funnelsItems"
				:label="AppHeaderService.currentRoleLabel.value"
				:chevron="false"
			>
				<template #label>
					<span class="workspace">
						<small>Рабочее пространство</small>
						<span>{{ AppHeaderService.currentRoleLabel.value }}</span>
					</span>
				</template>

				<template #default="{ query, close }">
					<VSearchPicker
						:query="query"
						:groups="AppHeaderService.availableFunnels"
						groups-selectable
						@pick="onPick($event, close)"
						@pick-group="onPickGroup($event, close)"
					/>
				</template>
			</AppHeaderNavDropdown>

			<hr>

			<a v-if="$core.currentPartner.isNamangan"
				class="item"
				href="https://drive.google.com/drive/u/0/folders/1GoleX-Am18xPjcmKWMmh8HTOno8XaLzK"
				target="_blank"
			>
				<VIcon material="help" theme="outlined"/>
				Помощь
			</a>

      <a v-else
        class="item"
        href="https://drive.google.com/drive/u/1/folders/1_kRW7X8FNY1l7IRLF0lR6fbYoyy8p7rJ"
        target="_blank"
      >
        <VIcon material="help" theme="outlined"/>
        Помощь
      </a>


      <hr>

			<button class="item" type="button" @click="$core.acl.logout()">
				<VIcon material="logout" theme="outlined"/>
				Выход
			</button>

		</div>

	</div>
</template>

<style lang="scss" src="./AppHeaderPartnerProfile.scss"/>

<script lang="ts">
import AppHeaderService, {
	NavGroup,
	type NavRoute
} from "@/lib/components/AppHeader/AppHeaderService";

export default defineComponent({
	name: 'AppHeaderPartnerProfile',

	props: {},

	setup() {
		return {
			AppHeaderService
		}
	},

	data() {
		return {
			isOpen: false as boolean,
		};
	},

	mounted() {
		document.addEventListener('mousedown', this.onDocumentMousedown);
	},

	beforeUnmount() {
		document.removeEventListener('mousedown', this.onDocumentMousedown);
	},

	methods: {
		onPick(item: NavRoute, close: () => void): void {
			this.$router.push({path: item.path, hash: item.hash});
			close();
      this.isOpen = false;
		},

		onPickGroup(group: NavGroup, close: () => void): void {
			AppHeaderService.setCurrentRoleLabel(group.label);
			close();
      this.isOpen = false;
		},

		toggleMenu(): void {
			this.isOpen = !this.isOpen;
		},

		goToProfile(): void {
			this.isOpen = false;

			this.$router.push({path: '/profile'});
		},

		onDocumentMousedown(event: MouseEvent): void {
			if (this.isOpen) {
				const wrap = this.$refs.wrapRef as HTMLElement;
				const dropdown = this.$refs.dropdownRef as { isClickInside: (e: MouseEvent) => boolean } | undefined;

				const inWrap     = wrap.contains(event.target as Node);
				const inDropdown = dropdown?.isClickInside(event) ?? false;

				if (!inWrap && !inDropdown) {
					this.isOpen = false;
				} else {
					// клик внутри враппера или попапа — не закрываем
				}
			} else {
				// меню закрыто — ничего не делаем
			}
		},
	},

	computed: {
    funnelsItems() {
      return AppHeaderService.availableFunnels.flatMap(group => group.items);
    },
		partnerName() {
			return this.$core?.currentPartner?.name;
		},
	}
});
</script>
